<template>
  <div class="vehicle-selector">
    <div class="field">
      <label class="label">Select Vehicle Type</label>
      <div class="control">
        <div class="columns is-multiline">
          <div
            v-for="vehicle in vehicleList"
            :key="vehicle.vehicle_id"
            class="column is-4"
          >
            <div
              class="vehicle-card"
              :class="{ 'is-selected': selectedVehicle && selectedVehicle.vehicle_id === vehicle.vehicle_id }"
              @click="selectVehicle(vehicle)"
            >
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-64x64">
                      <img :src="vehicle.vehicle_icon || vehicle.vehicle_image" :alt="vehicle.vehicle_title_en">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-6">{{ vehicle.vehicle_title_en }}</p>
                    <p class="subtitle is-7">{{ vehicle.vehicle_title_th }}</p>
                  </div>
                </div>

                <div class="content">
                  <div class="tags">
                    <span class="tag is-info is-light">
                      Size: {{ vehicle.vehicle_size_carry }}
                    </span>
                    <span class="tag is-success is-light">
                      Weight: {{ vehicle.vehicle_weight_carry }} kg
                    </span>
                  </div>

                  <div class="pricing">
                    <p class="has-text-weight-bold">
                      Base Price: {{ formatPrice(vehicle.vehicle_std_price) }} ฿
                    </p>
                    <p class="is-size-7">
                      Per Point: {{ formatPrice(vehicle.vehicle_price_per_point) }} ฿
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!vehicleList.length && isLoading" class="has-text-centered">
      <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
      <p>Loading vehicle options...</p>
    </div>

    <div v-if="!vehicleList.length && !isLoading" class="has-text-centered">
      <p class="has-text-grey">No vehicles available for this location</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeServeVehicleSelector",
  props: {
    value: {
      type: Object,
      default: null
    },
    location: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      selectedVehicle: this.value
    };
  },
  computed: {
    vehicleList() {
      return this.$store.getters["weserve/vehicleList"];
    }
  },
  watch: {
    value(newVal) {
      this.selectedVehicle = newVal;
    },
    location: {
      immediate: true,
      handler() {
        this.loadVehicles();
      }
    }
  },
  methods: {
    async loadVehicles() {
      if (!this.location || !this.location.lat || !this.location.lng) return;

      this.isLoading = true;
      try {
        await this.$store.dispatch("weserve/getVehicleList", {
          lat: this.location.lat,
          lng: this.location.lng
        });
      } catch (error) {
        console.error("Failed to load vehicles:", error);
        this.$buefy.notification.open({
          message: "Failed to load vehicle options",
          type: "is-danger",
          duration: 3000
        });
      } finally {
        this.isLoading = false;
      }
    },
    selectVehicle(vehicle) {
      this.selectedVehicle = vehicle;
      this.$emit("input", vehicle);
      this.$emit("vehicle-selected", vehicle);
    },
    formatPrice(price) {
      return parseFloat(price || 0).toFixed(2);
    }
  }
};
</script>

<style scoped>
.vehicle-selector {
  position: relative;
  min-height: 200px;
}

.vehicle-card {
  border: 2px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
}

.vehicle-card:hover {
  border-color: #3273dc;
  box-shadow: 0 4px 8px rgba(50, 115, 220, 0.2);
}

.vehicle-card.is-selected {
  border-color: #3273dc;
  background-color: #f0f8ff;
  box-shadow: 0 4px 12px rgba(50, 115, 220, 0.3);
}

.card-content {
  padding: 1rem;
}

.pricing {
  margin-top: 0.5rem;
}

.tags {
  margin-bottom: 0.5rem;
}

.image img {
  object-fit: contain;
}
</style>